import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nfts/shape.png'


const _hoisted_1 = {
  class: "mb-[25px] relative z-[1] pt-[20px] md:pt-[40px] lg:pt-[55px] px-[20px] md:px-[33px] rounded-md",
  id: "allNFTSlides"
}
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_3 = { class: "lg:col-span-1" }
const _hoisted_4 = { class: "lg:col-span-2" }
const _hoisted_5 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-[25px] mb-[25px]" }
const _hoisted_6 = { class: "lg:col-span-3" }
const _hoisted_7 = { class: "lg:col-span-1" }
const _hoisted_8 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px]" }
const _hoisted_9 = { class: "lg:col-span-2" }
const _hoisted_10 = { class: "lg:col-span-1" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-[25px] mb-[25px]" }
const _hoisted_12 = { class: "2xl:col-span-1 md:order-1 2xl:order-1" }
const _hoisted_13 = { class: "md:col-span-2 2xl:col-span-2 md:order-3 2xl:order-2" }
const _hoisted_14 = { class: "2xl:col-span-1 md:order-2 2xl:order-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManageYourNFT = _resolveComponent("ManageYourNFT")!
  const _component_NFTSlideItem = _resolveComponent("NFTSlideItem")!
  const _component_EthereumRate = _resolveComponent("EthereumRate")!
  const _component_ActiveAuctions = _resolveComponent("ActiveAuctions")!
  const _component_FeaturedNFTArtworks = _resolveComponent("FeaturedNFTArtworks")!
  const _component_NewMobileApp = _resolveComponent("NewMobileApp")!
  const _component_MostPopularSellers = _resolveComponent("MostPopularSellers")!
  const _component_WorldwideTopCreators = _resolveComponent("WorldwideTopCreators")!
  const _component_TopCollections = _resolveComponent("TopCollections")!
  const _component_TopNFTs = _resolveComponent("TopNFTs")!
  const _component_HistoryOfBids = _resolveComponent("HistoryOfBids")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ManageYourNFT),
      _createVNode(_component_NFTSlideItem),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"nft-swiper-button-prev absolute ltr:-left-[8px] rtl:-right-[8px] bottom-[145px] w-[25px] md:w-[30px] h-[25px] md:h-[30px] rounded-full bg-black text-primary-200 text-center leading-[24px] md:leading-[29px] transition-all hover:bg-primary-500 text-white\"><i class=\"ri-arrow-left-line\"></i></div><div class=\"nft-swiper-button-next absolute ltr:-right-[8px] rtl:-left-[8px] bottom-[145px] w-[25px] md:w-[30px] h-[25px] md:h-[30px] rounded-full bg-black text-primary-200 text-center leading-[24px] md:leading-[29px] transition-all hover:bg-primary-500 text-white\"><i class=\"ri-arrow-right-line\"></i></div><div class=\"absolute top-0 left-0 right-0 rounded-md -z-[1] h-[54%]\" style=\"background:linear-gradient(92deg, #23272e 7.31%, #3f5272 97.89%);\"></div><img src=\"" + _imports_0 + "\" class=\"absolute top-0 ltr:right-0 rtl:left-0 -z-[1]\" alt=\"shape\">", 4))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_EthereumRate)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ActiveAuctions)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FeaturedNFTArtworks)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_NewMobileApp)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_MostPopularSellers)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_WorldwideTopCreators)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_TopCollections)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_TopNFTs)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_HistoryOfBids)
      ])
    ])
  ], 64))
}